"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[28225],{

/***/ 251317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ReviewSection": function() { return /* binding */ ReviewSection; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-react-virtual-2705a56d4f/0/cache/@emotion-react-npm-11.5.0-7e3b735976-4188b664cc.zip/node_modules/@emotion/react/dist/emotion-element-99289b21.browser.esm.js
var emotion_element_99289b21_browser_esm = __webpack_require__(554542);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-c19f22b4e3/0/cache/swr-npm-2.3.6-1a69322beb-c7cc7dfb73.zip/node_modules/swr/dist/index/index.mjs + 4 modules
var index = __webpack_require__(908891);
;// CONCATENATED MODULE: ../../.yarn/cache/@teko-ui-review-npm-0.0.11-ab9accb975-4a787adaac.zip/node_modules/@teko-ui/review/dist/supabase.es.js
const supabaseConfig = {
    projectId: "znjwerebknrwosrxqcxx",
    apiKey: "sb_publishable_0CAjs0FRc_mTXLcIuNfqcA_cDdhnJD9",
};
const requestSupabase = (path, method, payload, config = supabaseConfig) => {
    const apiUrl = `https://${supabaseConfig.projectId}.supabase.co/${path}`;
    return fetch(apiUrl, {
        method,
        headers: {
            apikey: config.apiKey,
            Authorization: `Bearer ${config.apiKey}`,
            "Content-Type": "application/json",
        },
        body: method === "POST" ? JSON.stringify(payload ?? {}) : undefined,
    })
        .then((res) => res.json())
        .catch((err) => {
        throw new Error(err.message);
    });
};
const fetchReviews = (appId, entity, config) => {
    return requestSupabase(`functions/v1/rate-summary`, "POST", {
        appId: appId,
        ...entity,
    }, config);
};
const postReview = (appId, entityKey, review, config) => {
    return requestSupabase(`rest/v1/rpc/add_entity_review`, "POST", {
        entity_key: entityKey,
        review_rate: review.rate,
        review_content: review.comment,
    }, config);
};



;// CONCATENATED MODULE: ../../.yarn/cache/@teko-ui-review-npm-0.0.11-ab9accb975-4a787adaac.zip/node_modules/@teko-ui/review/dist/context.es.js





const defaultConfig = {
    theme: {
        colors: {
            primary: "#0070f3",
            primaryActive: "#005bb5",
            primaryHover: "#3291ff",
            starColor: "#ffb400",
        },
        borderRadius: "4px",
    },
    labels: {
        rateNow: "Đánh giá ngay",
        rate: "đánh giá",
        title: "Bạn đánh giá sao về sản phẩm này?",
        description: "Chia sẻ cảm nhận của bạn về sản phẩm này",
        modalTitle: "Đánh giá sản phẩm",
        commentPlaceholder: "Viết đánh giá của bạn ở đây...",
        sendReview: "Gửi đánh giá",
    },
};
const TekReviewContext = react.createContext({});
const useTekReviewContext = () => {
    const context = react.useContext(TekReviewContext);
    if (!context) {
        throw new Error("useTekReviewContext must be used within a TekReviewProvider");
    }
    return context;
};
const TekReviewProvider = ({ children, appId, entity, theme, labels, onRequestLogin, reviewer }) => {
    const { data: reviewSummary, isLoading, mutate, } = (0,index/* default */.ZP)([`/api/reviews/summary`, appId, entity], async ([, appId, entity]) => {
        return fetchReviews(appId, entity);
    }, {
        revalidateIfStale: false,
        keepPreviousData: true,
        revalidateOnMount: true,
        revalidateOnFocus: false,
    });
    const onSubmitReview = async (formValue) => {
        try {
            await postReview(appId, entity.key, formValue);
            await mutate();
        }
        catch (err) { }
    };
    return (react.createElement(TekReviewContext.Provider, { value: {
            ...defaultConfig,
            summary: {
                averageRating: Math.floor((reviewSummary?.averageRating || 0) * 10) / 10,
                totalReviews: reviewSummary?.totalReviews || 0,
            },
            loading: isLoading,
            onSubmitReview,
            labels: {
                ...defaultConfig.labels,
                ...labels,
            },
            reviewer,
            onRequestLogin,
            entity,
        } },
        react.createElement(emotion_element_99289b21_browser_esm.a, { theme: {
                colors: {
                    primary: theme?.colors?.primary ?? defaultConfig.theme?.colors?.primary,
                    primaryActive: theme?.colors?.primaryActive ??
                        theme?.colors?.primary ??
                        defaultConfig.theme?.colors?.primaryActive,
                    primaryHover: theme?.colors?.primaryHover ??
                        theme?.colors?.primary ??
                        defaultConfig.theme?.colors?.primaryHover,
                    starColor: theme?.colors?.starColor ??
                        defaultConfig.theme?.colors?.starColor,
                },
                borderRadius: theme?.borderRadius ?? defaultConfig.theme?.borderRadius,
            } }, children)));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-7f4a1492f4/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(851126);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-react-virtual-2705a56d4f/0/cache/@emotion-react-npm-11.5.0-7e3b735976-4188b664cc.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(783768);
// EXTERNAL MODULE: ../../.yarn/cache/clsx-npm-1.1.1-362bec0598-ff05265032.zip/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(877084);
;// CONCATENATED MODULE: ../../.yarn/cache/@teko-ui-review-npm-0.0.11-ab9accb975-4a787adaac.zip/node_modules/@teko-ui/review/dist/components/Button.es.js





const Button = react.forwardRef(({ children, className, loading, variant = "primary", icon, size = "md", block, outline, iconPosition = "left", fontWeight = 400, shadow = true, ...props }, ref) => {
    const renderIcon = () => {
        return loading ? react.createElement("span", { className: "spin" }) : icon && react.createElement("span", null, icon);
    };
    return (react.createElement(ButtonStyles, { fontWeight: fontWeight, ref: ref, className: (0,clsx_m["default"])(`btn-size-${size}`, {
            "btn-primary": variant === "primary",
            "btn-outline": !!outline,
            "btn-shadow": !!shadow,
            "btn-block": !!block,
        }, className), style: {
            pointerEvents: loading ? "none" : undefined,
        }, ...props },
        iconPosition === "left" && renderIcon(),
        children,
        iconPosition === "right" && renderIcon()));
});
const rotate = emotion_react_browser_esm/* keyframes */.F4 `
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const ButtonStyles = emotion_styled_browser_esm/* default.button */.Z.button `
  --btn-radius: ${(props) => props.theme.borderRadius || "8px"};
  --btn-padding-x: 4px;
  --btn-gap: 8px;
  --btn-height: 36px;
  --btn-text-color: #ffffff;

  justify-content: center;

  align-items: center;
  padding: 0px var(--btn-padding-x);
  gap: var(--btn-gap);
  display: inline-flex;

  position: relative;

  font-weight: 500;

  /* --btn-height: 40px; */

  height: var(--btn-height);
  line-height: var(--btn-height);
  border-radius: var(--btn-radius);

  font-weight: ${(props) => props.fontWeight ?? 500};

  // &.btn-shadow {
  //   box-shadow: 0px -3px 3px 0px var(--btn-active-background) inset;
  // }

  width: auto;
  background-color: var(--btn-background);
  color: var(--btn-text-color);
  border: 1px solid var(--btn-border-color);
  cursor: pointer;
  transition: background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:hover,
  &:focus,
  &:focus-visible {
    background-color: var(--btn-hover-background);
  }

  &:active {
    background-color: var(--btn-active-background);
    box-shadow: 0px -1px 1px 0px var(--btn-border-color) inset;
  }

  &.btn-outline {
    background-color: transparent;
    color: var(--btn-background);
    border: 1px solid var(--btn-background);
  }

  .animate-spin {
  }

  :focus-visible {
    outline: none;
  }

  :disabled {
    cursor: not-allowed;
    opacity: 0.75;
  }

  &.btn-primary {
    --btn-background: ${(props) => props.theme.colors.primary};
    --btn-hover-background: ${(props) => props.theme.colors.primaryHover || props.theme.colors.primary};
    --btn-active-background: ${(props) => props.theme.colors.primaryActive || props.theme.colors.primary};
  }

  &.btn-block {
    width: 100%;
  }

  /* sizes */
  &.btn-size-sm {
    --btn-height: 32px;
    --btn-padding-x: 8px;
    --btn-gap: 6px;
    font-size: 0.625rem;
  }
  &.btn-size-md {
    --btn-height: 36px;
    --btn-padding-x: 12px;
    --btn-gap: 8px;
    font-size: 0.95rem;
  }
  &.btn-size-lg {
    --btn-height: 40px;
    --btn-padding-x: 14px;
    --btn-gap: 10px;
    font-size: 1rem;
  }
  &.btn-size-xl {
    --btn-height: 48px;
    --btn-padding-x: 16px;
    --btn-gap: 12px;
    font-size: 1.05rem;
  }

  // spin
  //inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full

  .prefix {
    min-width: 1rem;
  }

  transition: all 0.2s ease-in-out;

  .spin {
    display: inline-block;
    width: 0.625rem;
    height: 0.625rem;
    border: 2px solid var(--btn-text-color);
    border-top-color: transparent;
    border-radius: 50%;
    animation: ${rotate} 1s linear infinite;
    position: relative;
  }
`;
Button.displayName = "Button";



// EXTERNAL MODULE: ../../.yarn/__virtual__/react-dom-virtual-d2a5f90a4a/0/cache/react-dom-npm-18.2.0-dd675bca1c-7d323310be.zip/node_modules/react-dom/index.js
var react_dom = __webpack_require__(926759);
;// CONCATENATED MODULE: ../../.yarn/cache/@teko-ui-review-npm-0.0.11-ab9accb975-4a787adaac.zip/node_modules/@teko-ui/review/dist/components/Modal.es.js






const Portal = ({ children }) => {
    return (0,react_dom.createPortal)(children, document.body);
};
const Modal = react.forwardRef(({ isOpen, onClose, title, footer, children, size = "md", closeOnBackdrop = true, showClose = true, className, }, ref) => {
    const panelRef = react.useRef(null);
    const closeModal = react.useCallback(() => {
        if (panelRef.current) {
            panelRef.current.classList.add("close");
        }
        setTimeout(() => {
            onClose();
        }, 300);
    }, []);
    (0,react.useImperativeHandle)(ref, () => ({
        close: closeModal,
    }));
    react.useEffect(() => {
        if (!isOpen)
            return;
        const onKeyDown = (e) => {
            if (e.key === "Escape") {
                closeModal();
            }
        };
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [isOpen, closeModal]);
    if (!isOpen)
        return null;
    const sizeClass = getSizeClass(size);
    return (react.createElement(Portal, null,
        react.createElement(Dialog, { ref: panelRef, "aria-modal": "true", role: "dialog" },
            react.createElement(Backdrop, { className: "backdrop", onClick: () => {
                    if (closeOnBackdrop)
                        closeModal();
                } }),
            react.createElement(ModalBody, { tabIndex: -1, "data-size": sizeClass, className: (0,clsx_m["default"])("modal-body", className ?? ""), onClick: (e) => e.stopPropagation() },
                title && (react.createElement(Header, null,
                    react.createElement(Title, null, title))),
                showClose && (react.createElement(CloseButton, { type: "button", "aria-label": "Close", onClick: closeModal },
                    react.createElement(CloseIcon, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2" },
                        react.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M6 18L18 6M6 6l12 12" })))),
                react.createElement(Content, null, children),
                footer && react.createElement(Footer, null, footer)))));
});
Modal.displayName = "Modal";
const ModalBody = emotion_styled_browser_esm/* default.div */.Z.div `
  font-family: "Roboto", sans-serif;
  position: relative;
  margin: 0 1rem;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 8px 10px -6px rgba(0, 0, 0, 0.1);
  outline: none;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;

  /* size handling */
  &[data-size="max-w-sm"] {
    max-width: 24rem; /* 384px */
  }
  &[data-size="max-w-md"] {
    max-width: 28rem; /* 448px */
  }
  &[data-size="max-w-lg"] {
    max-width: 32rem; /* 512px */
  }
  &[data-size="max-w-xl"] {
    max-width: 36rem; /* 576px */
  }
  &[data-size="max-w-2xl"] {
    max-width: 42rem; /* 672px */
  }
  &[data-size="full"] {
    max-width: none;
    width: 90vw;
    height: 90vh;
    border-radius: 8px;
  }
  &[data-size="default"] {
    max-width: 28rem;
    max-height: 90vh;
    overflow: hidden;
  }

  // @media (prefers-color-scheme: dark) {
  //   background-color: #171717; /* neutral-900 */
  // }
`;
const topToBottomKeyframes = emotion_react_browser_esm/* keyframes */.F4 `
  from {
    transform: translateY(-50px);
  }
  to {
    transform: translateY(0);
  }
`;
const bottomToTopKeyframes = emotion_react_browser_esm/* keyframes */.F4 `
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-50px);
  }
`;
const Dialog = emotion_styled_browser_esm/* default.div */.Z.div `
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;

  .modal-body {
    animation: ${topToBottomKeyframes} 0.3s ease-out;
    transition: opacity 0.3s ease-out;
  }

  &.close {
    .modal-body {
      animation: ${bottomToTopKeyframes} 0.3s ease-out;
      opacity: 0;
    }

    .backdrop {
      opacity: 0;
    }
  }
`;
const Backdrop = emotion_styled_browser_esm/* default.div */.Z.div `
  position: absolute;
  inset: 0;
  transition: opacity 0.3s ease-out;
  background-color: rgba(0, 0, 0, 1);
  opacity: 0.25;
`;
const Header = emotion_styled_browser_esm/* default.div */.Z.div `
  display: flex;
  align-items: center;
  justify-content: center;
  // border-bottom: 1px solid #bcbfd6; /* neutral-200 */
  padding: 16px;
  text-align: center;

  // @media (prefers-color-scheme: dark) {
  //   border-color: #262626; /* neutral-800 */
  // }
`;
const Title = emotion_styled_browser_esm/* default.div */.Z.div `
  font-size: 1.25rem;
  font-weight: 600;

  // @media (prefers-color-scheme: dark) {
  //   color: #f5f5f5; /* neutral-100 */
  // }
`;
const CloseButton = emotion_styled_browser_esm/* default.button */.Z.button `
  position: absolute;
  right: 8px;
  top: 8px;
  z-index: 10;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  color: #737373; /* neutral-500 */
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    background-color: #f5f5f5; /* neutral-100 */
    color: #404040; /* neutral-700 */
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px #d4d4d4; /* neutral-300 */
  }

  @media (prefers-color-scheme: dark) {
    color: #a3a3a3; /* neutral-400 */
    &:hover {
      background-color: #262626; /* neutral-800 */
      color: #e5e5e5; /* neutral-200 */
    }
  }
`;
const CloseIcon = emotion_styled_browser_esm/* default.svg */.Z.svg `
  width: 20px;
  height: 20px;
`;
const Content = emotion_styled_browser_esm/* default.div */.Z.div `
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  color: #404040; /* neutral-700 */
  overflow-y: auto;
  padding: 16px;
  padding-top: 0;

  // @media (prefers-color-scheme: dark) {
  //   color: #e5e5e5; /* neutral-200 */
  // }
`;
const Footer = emotion_styled_browser_esm/* default.div */.Z.div `
  border-top: 1px solid #e5e5e5; /* neutral-200 */
  padding: 16px;

  // @media (prefers-color-scheme: dark) {
  //   border-color: #262626; /* neutral-800 */
  // }
`;
Modal.displayName = "Modal";
function getSizeClass(size) {
    switch (size) {
        case "sm":
            return "max-w-sm";
        case "md":
            return "max-w-md";
        case "lg":
            return "max-w-lg";
        case "xl":
            return "max-w-xl";
        case "2xl":
            return "max-w-2xl";
        case "full":
            return "full";
        default:
            return "default";
    }
}



;// CONCATENATED MODULE: ../../.yarn/cache/@teko-ui-review-npm-0.0.11-ab9accb975-4a787adaac.zip/node_modules/@teko-ui/review/dist/components/Star.es.js



const Star = ({ filled = 0.5, inactiveColor = "lightgray", ...props }) => {
    const id = (0,react.useMemo)(() => Math.random().toString(36).substring(2, 15), []);
    return (react.createElement(Icon, { width: props.size || 32, height: props.size || 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        react.createElement("g", null,
            react.createElement("path", { d: "M10.9907 9.78666L2.48405 11.02L2.33339 11.0507C2.10531 11.1112 1.89738 11.2312 1.73084 11.3984C1.56431 11.5656 1.44513 11.774 1.38547 12.0023C1.32582 12.2306 1.32782 12.4707 1.39129 12.698C1.45476 12.9252 1.57741 13.1316 1.74672 13.296L7.90939 19.2947L6.45605 27.768L6.43872 27.9147C6.42476 28.1506 6.47374 28.3859 6.58065 28.5967C6.68757 28.8074 6.84857 28.9859 7.04717 29.114C7.24577 29.2421 7.47484 29.315 7.71092 29.3255C7.947 29.3359 8.18161 29.2834 8.39072 29.1733L15.9987 25.1733L23.5894 29.1733L23.7227 29.2347C23.9428 29.3213 24.182 29.3479 24.4157 29.3117C24.6495 29.2754 24.8694 29.1776 25.0528 29.0283C25.2363 28.8791 25.3768 28.6837 25.4598 28.4622C25.5429 28.2407 25.5655 28.0011 25.5254 27.768L24.0707 19.2947L30.2361 13.2947L30.34 13.1813C30.4886 12.9983 30.586 12.7793 30.6223 12.5464C30.6587 12.3135 30.6326 12.0752 30.5468 11.8556C30.4611 11.6361 30.3186 11.4432 30.134 11.2967C29.9494 11.1501 29.7293 11.0551 29.4961 11.0213L20.9894 9.78666L17.1867 2.07999C17.0767 1.8567 16.9063 1.66867 16.695 1.53719C16.4836 1.40571 16.2396 1.33603 15.9907 1.33603C15.7418 1.33603 15.4978 1.40571 15.2865 1.53719C15.0751 1.66867 14.9048 1.8567 14.7947 2.07999L10.9907 9.78666Z", fill: `url(#grad${id})` })),
        react.createElement("defs", null,
            react.createElement("linearGradient", { id: `grad${id}` },
                react.createElement("stop", { offset: `${filled * 100}%`, stopColor: "currentColor" }),
                react.createElement("stop", { offset: `${filled * 100}%`, stopColor: inactiveColor })))));
};
const Icon = emotion_styled_browser_esm/* default.svg */.Z.svg `
  /* rotate */

  ${(props) => props.rotate && `transform: rotate(${props.rotate}deg);`}
`;



;// CONCATENATED MODULE: ../../.yarn/cache/@teko-ui-review-npm-0.0.11-ab9accb975-4a787adaac.zip/node_modules/@teko-ui/review/dist/components/Rating.es.js




const Rating = ({ value = 3, onChange, readonly, size, }) => {
    const ref = react.useRef(null);
    const handleHoverStar = (index) => {
        if (readonly)
            return;
        ref.current?.childNodes.forEach((node, idx) => {
            const starElement = node;
            if (idx < index) {
                starElement.classList.add("hovered");
            }
            else {
                starElement.classList.remove("hovered");
            }
        });
    };
    return (react.createElement(Wrapper, { ref: ref, onMouseLeave: () => handleHoverStar(value || 0) }, Array.from({ length: 5 }).map((_, index) => {
        const isHaftStar = Math.floor(value) === index && value % 1 !== 0;
        return (react.createElement("button", { key: index, className: `star-btn ${value && index < value ? "selected" : ""}`, onMouseEnter: () => handleHoverStar(index + 1), onClick: () => onChange && onChange(index + 1) },
            react.createElement(Star, { filled: isHaftStar ? 0.5 : 1, inactiveColor: "#e0e0e0", size: size || 20 })));
    })));
};
const Wrapper = emotion_styled_browser_esm/* default.div */.Z.div `
  display: inline-flex;
  gap: 8px;

  .star-btn {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    color: ${(props) => props.theme.colors.starColor || "#ffb400"};

    transition: color 0.2s;

    &.selected {
      opacity: 1 !important;
    }

    &.hovered {
      color: ${(props) => props.theme.colors.starColor || "#ffb400"} !important;
    }

    &:not(.selected) {
      color: #e0e0e0;
    }
  }
`;



;// CONCATENATED MODULE: ../../.yarn/cache/@teko-ui-review-npm-0.0.11-ab9accb975-4a787adaac.zip/node_modules/@teko-ui/review/dist/components/ReviewForm.es.js






const ReviewForm = ({ afterSubmit }) => {
    const [state, setState] = (0,react.useState)({
        rate: 0,
        comment: "",
    });
    const [loading, setLoading] = (0,react.useState)(false);
    const { onSubmitReview, labels, entity } = useTekReviewContext();
    const handleSubmit = async () => {
        setLoading(true);
        try {
            await onSubmitReview(state);
            setState({ rate: 0, comment: "" });
            afterSubmit?.();
        }
        catch (err) {
        }
        finally {
            setLoading(false);
        }
    };
    return (react.createElement(ReviewForm_es_Wrapper, { className: "review-form" },
        entity.title && (react.createElement("div", { className: "entity" },
            entity.imageUrl && (react.createElement("img", { className: "entity-img", src: entity.imageUrl })),
            react.createElement("div", { className: "entity-info" },
                react.createElement("div", { className: "entity-title" }, entity.title),
                react.createElement("div", { className: "entity-sub-title" }, entity.subTitle)))),
        react.createElement(Container, null,
            react.createElement(RateContainer, null,
                react.createElement("div", null, labels.description),
                react.createElement(Rating, { value: state.rate, onChange: (value) => setState({ ...state, rate: value }), size: 30 })),
            react.createElement(TextArea, { placeholder: labels.commentPlaceholder, value: state.comment, onChange: (e) => setState({ ...state, comment: e.target.value }) })),
        react.createElement(Button, { loading: loading, block: true, onClick: () => handleSubmit(), disabled: state.rate === 0 || loading }, labels.sendReview)));
};
const ReviewForm_es_Wrapper = emotion_styled_browser_esm/* default.div */.Z.div `
  .entity {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    padding: 6px 8px;
    border: 1px solid #e0e0e0;
    border-radius: ${({ theme }) => theme.borderRadius || "8px"};

    .entity-img {
      width: 44px;
      height: 44px;
      object-fit: cover;
      border-radius: 8px;
    }

    .entity-info {
      display: flex;
      flex-direction: column;
      gap: 4px;

      .entity-title {
        font-weight: 600;
        font-size: 13px;
        line-height: 1.5;

        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .entity-sub-title {
        font-size: 12px;
        color: #666;
      }
    }
  }
`;
const Container = emotion_styled_browser_esm/* default.div */.Z.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  background-color: #fafafa;
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 8px;
`;
const RateContainer = emotion_styled_browser_esm/* default.div */.Z.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;
const TextArea = emotion_styled_browser_esm/* default.textarea */.Z.textarea `
  width: 100%;
  height: 100px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  outline: none;
  box-sizing: border-box;

  border-radius: 8px;

  &:focus {
    border-color: ${(props) => props.theme?.colors.primary || "#0070f3"};
  }
`;



;// CONCATENATED MODULE: ../../.yarn/cache/@teko-ui-review-npm-0.0.11-ab9accb975-4a787adaac.zip/node_modules/@teko-ui/review/dist/TekReview.es.js









const TekReview = (props) => {
    const [openModal, setModalOpen] = react.useState(false);
    return (react.createElement(TekReviewProvider, { ...props },
        react.createElement(ReviewCard, { onRequestReview: () => setModalOpen(true) }),
        react.createElement(ReviewModal, { isOpen: openModal, setIsOpen: setModalOpen })));
};
const ReviewCard = ({ onRequestReview }) => {
    const { labels, summary, loading, reviewer, onRequestLogin } = useTekReviewContext();
    const handleRequestReview = () => {
        if (!reviewer) {
            onRequestLogin?.();
            return;
        }
        onRequestReview?.();
    };
    if (loading) {
        return (react.createElement(ReviewContainer, null,
            react.createElement("div", { className: "review-summary" },
                react.createElement("div", { className: "skeleton sk-avg-rating" }),
                react.createElement("div", { className: "skeleton sk-stars" }),
                react.createElement("div", { className: "skeleton sk-review-count" })),
            react.createElement("div", { className: "divider" }),
            react.createElement("div", { className: "review-action" },
                react.createElement("div", { className: "review-question" }, labels.title),
                react.createElement(Button, { className: "btn-review", onClick: handleRequestReview, disabled: loading }, labels.rateNow))));
    }
    return (react.createElement(ReviewContainer, null,
        react.createElement("div", { className: "review-summary" },
            react.createElement("div", { className: "avg-rating" }, summary?.averageRating),
            react.createElement(Rating, { value: summary?.averageRating, size: 24 }),
            react.createElement("div", { className: "review-count" },
                summary?.totalReviews,
                " ",
                labels.rate)),
        react.createElement("div", { className: "divider" }),
        react.createElement("div", { className: "review-action" },
            react.createElement("div", { className: "review-question" }, labels.title),
            react.createElement(Button, { className: "btn-review", onClick: handleRequestReview, disabled: loading }, labels.rateNow))));
};
const ReviewModal = ({ isOpen, setIsOpen }) => {
    const { labels } = useTekReviewContext();
    const modalRef = react.useRef(null);
    return (react.createElement(Modal, { ref: modalRef, isOpen: isOpen, onClose: () => setIsOpen(false), size: "lg", title: labels.modalTitle, showClose: false },
        react.createElement(ReviewForm, { afterSubmit: modalRef?.current?.close })));
};
const ReviewContainer = emotion_styled_browser_esm/* default.div */.Z.div `
  display: flex;
  min-height: 100px;
  .skeleton {
    position: relative;
    overflow: hidden;
    background-color: #eee;
    border-radius: 6px;
  }

  .skeleton::after {
    content: "";
    position: absolute;
    inset: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.6) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: shimmer 1.2s infinite;
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }

  .review-summary {
    min-width: 200px;
    max-width: 100%;
    padding: 16px 16px;
    display: flex;
    justify-content: space;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    .avg-rating {
      font-size: 24px;
      font-weight: 600;
    }

    .sk-avg-rating {
      width: 44px;
      height: 28px;
    }

    .sk-stars {
      width: 120px;
      height: 24px;
    }

    .review-count {
      color: ${(props) => props.theme.colors.primary};
      font-size: 14px;
    }

    .sk-review-count {
      width: 100px;
      height: 14px;
    }
  }

  .divider {
    width: 1px;
    background-color: #ebeaea;
    margin: 8px 0;
  }

  .review-action {
    flex: 1;
    padding: 32px 16px;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    gap: 16px;
    display: flex;

    font-weight: 600;

    .btn-review {
      min-width: 150px;
    }
  }

  // mobile responsive
  @media screen and (max-width: 480px) {
    flex-direction: column;

    .divider {
      width: 100%;
      height: 1px;
      margin: 0;
    }
  }
`;



;// CONCATENATED MODULE: ../../.yarn/cache/@teko-ui-review-npm-0.0.11-ab9accb975-4a787adaac.zip/node_modules/@teko-ui/review/dist/index.es.js


// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/contexts/Theme.es.js
var Theme_es = __webpack_require__(348855);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_es = __webpack_require__(411213);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var dist_emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(983546);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/BlockHeader/BlockHeader.es.js
var BlockHeader_es = __webpack_require__(842918);
;// CONCATENATED MODULE: ./modules/product-detail/shared/ReviewSection.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n  .title {\n    padding: 0 8px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








const ReviewSection = (param)=>{
    let { product , wrapperBorderRadius  } = param;
    var ref, ref1;
    const { colors , borderRadius  } = (0,Theme_es/* useTheme */.F)();
    const { tekReviewAppId  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { user , authService  } = (0,context_es/* useAuth */.aC)();
    const { 0: show , 1: setShow  } = (0,react.useState)(false);
    if (!tekReviewAppId) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewSection_Wrapper, {
        wrapperBorderRadius: wrapperBorderRadius,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBlockHeader, {
                title: "Đ\xe1nh gi\xe1 sản phẩm",
                borderColor: "#ebeaea"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TekReview, {
                appId: tekReviewAppId,
                entity: {
                    key: product.sku,
                    imageUrl: ((ref = product.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.src) || "",
                    title: product.name
                },
                theme: {
                    colors: {
                        primary: colors.primary,
                        primaryActive: colors.primary600,
                        primaryHover: colors.primary700
                    },
                    borderRadius: borderRadius.s
                },
                reviewer: user ? {
                    displayName: user.name,
                    avatarUrl: user.avatar,
                    email: user.email,
                    phoneNumber: user.telephone
                } : undefined,
                onRequestLogin: ()=>setShow(true)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_es/* Modal */.u, {
                visible: show,
                title: (0,i18n.t)("Đăng nhập"),
                okText: (0,i18n.t)("Đăng nhập"),
                cancelText: (0,i18n.t)("Hủy"),
                onOk: ()=>{
                    authService === null || authService === void 0 ? void 0 : authService.login(window.location.href);
                },
                onCancel: ()=>{
                    setShow(false);
                },
                footer: true,
                onBackDrop: ()=>setShow(false),
                children: (0,i18n.t)("Vui l\xf2ng đăng nhập để đ\xe1nh gi\xe1 sản phẩm.")
            })
        ]
    });
};
const ReviewSection_Wrapper = dist_emotion_styled_browser_esm["default"].div((param)=>{
    let { wrapperBorderRadius  } = param;
    return "\n  position: relative;\n  background-color: #fff;\n  margin-top: 8px;\n  margin-bottom: 0.5rem;\n  border-radius: ".concat(wrapperBorderRadius || "0px", ";\n");
});
const StyledBlockHeader = (0,dist_emotion_styled_browser_esm["default"])(BlockHeader_es/* BlockHeader */.t)(_templateObject(), (props)=>props.borderColor);


/***/ }),

/***/ 930492:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var React = __webpack_require__(891987);
function is(x, y) {
  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
}
var objectIs = "function" === typeof Object.is ? Object.is : is,
  useState = React.useState,
  useEffect = React.useEffect,
  useLayoutEffect = React.useLayoutEffect,
  useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
  var value = getSnapshot(),
    _useState = useState({ inst: { value: value, getSnapshot: getSnapshot } }),
    inst = _useState[0].inst,
    forceUpdate = _useState[1];
  useLayoutEffect(
    function () {
      inst.value = value;
      inst.getSnapshot = getSnapshot;
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
    },
    [subscribe, value, getSnapshot]
  );
  useEffect(
    function () {
      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      return subscribe(function () {
        checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
      });
    },
    [subscribe]
  );
  useDebugValue(value);
  return value;
}
function checkIfSnapshotChanged(inst) {
  var latestGetSnapshot = inst.getSnapshot;
  inst = inst.value;
  try {
    var nextValue = latestGetSnapshot();
    return !objectIs(inst, nextValue);
  } catch (error) {
    return !0;
  }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
  return getSnapshot();
}
var shim =
  "undefined" === typeof window ||
  "undefined" === typeof window.document ||
  "undefined" === typeof window.document.createElement
    ? useSyncExternalStore$1
    : useSyncExternalStore$2;
exports.useSyncExternalStore =
  void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;


/***/ }),

/***/ 45901:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



if (true) {
  module.exports = __webpack_require__(930492);
} else {}


/***/ }),

/***/ 877084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
}


/***/ }),

/***/ 49999:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ dequal; }
/* harmony export */ });
var has = Object.prototype.hasOwnProperty;

function dequal(foo, bar) {
	var ctor, len;
	if (foo === bar) return true;

	if (foo && bar && (ctor=foo.constructor) === bar.constructor) {
		if (ctor === Date) return foo.getTime() === bar.getTime();
		if (ctor === RegExp) return foo.toString() === bar.toString();

		if (ctor === Array) {
			if ((len=foo.length) === bar.length) {
				while (len-- && dequal(foo[len], bar[len]));
			}
			return len === -1;
		}

		if (!ctor || typeof foo === 'object') {
			len = 0;
			for (ctor in foo) {
				if (has.call(foo, ctor) && ++len && !has.call(bar, ctor)) return false;
				if (!(ctor in bar) || !dequal(foo[ctor], bar[ctor])) return false;
			}
			return Object.keys(bar).length === len;
		}
	}

	return foo !== foo && bar !== bar;
}


/***/ })

}]);